export const members = {
    member: 'MEMBER',
    role: 'MEMBERS.ROLE',
    managedByDirectory: 'MEMBERS.MANAGED_BY_DIRECTORY',
    deactivated: 'MEMBERS.DEACTIVATED',
    ssoRemoval: {
        title: 'MEMBERS.SSO_REMOVAL.TITLE',
        withoutDirectory: 'MEMBERS.SSO_REMOVAL.WITHOUT_DIRECTORY',
        withDirectory: 'MEMBERS.SSO_REMOVAL.WITH_DIRECTORY'
    },
    join: 'MEMBERS.JOIN',
    invitations: 'MEMBERS.INVITATION',
    invitationDate: 'MEMBERS.INVITATION_DATE',
    default: 'MEMBERS.DEFAULT',
    collaborators: {
        default: 'MEMBERS.COLLABORATORS.DEFAULT',
        description: 'MEMBERS.COLLABORATORS.DESCRIPTION'
    },
    pendingRequests: {
        default: 'MEMBERS.PENDING_REQUESTS.DEFAULT',
        description: 'MEMBERS.PENDING_REQUESTS.DESCRIPTION',
        empty: 'MEMBERS.PENDING_REQUESTS.EMPTY'
    }
};
